<template>

    <Button
        type="button"
        @click="form.is_open=true"
        :class="`${admission.university_fees_is_paid?'bg-green-600 text-primary-light hover:!bg-green-300 ':'bg-red-600 text-primary-light hover:!bg-red-300 hover:border-white'}`">
        University Fees {{ admission.university_fees_is_paid ? "Mark as Unpaid!" : "Mark as Paid!" }}
    </Button>
    <Model :is-open="form.is_open">
        <template #body>
            <div class="flex-grow">
                <div class="flex justify-between ">
                    <p class="text-lg font-medium ">
                        {{
                            admission.university_fees_is_paid ? "Are you sure you want to university fees marked as unpaid." : "Are you sure you want to university fees marked as paid."
                        }}
                    </p>
                </div>
            </div>
        </template>
        <template #buttons>
            <div class="flex justify-end">
                <Button @click="form.is_open=false"
                        class="bg-red-600 text-primary-light hover:!bg-red-300 hover:border-white mx-4">Cancel
                </Button>
                <Button @click="handleToggleFees" class="mr-2">Yes</Button>
            </div>
        </template>
    </Model>
</template>
<script setup>
import {useForm, usePage} from "@inertiajs/inertia-vue3";
import Button from "@/Components/Button.vue";
import {computed} from "vue";
import Model from "@/Components/Model.vue";

const admission = computed(() => usePage().props.value.admission);

const form = useForm({is_open: false});
const branchId = localStorage.branchId;
const handleToggleFees = () => {
    form.post(route('internal.admission.toggle-university-fees', [branchId, admission.value.id]), {
        preserveScroll: true,
        onSuccess: () => {
            form.reset();
        }
    })
}
</script>
